import PropTypes from 'prop-types';

export const CERT_TILE_MOCK_DATA = {
  certkey: PropTypes.number,
  statusLabel: PropTypes.string,
  statusActionLabel: PropTypes.string,
  certificationStatus: PropTypes.number,
  certificationName: PropTypes.string,
  campaignKey: PropTypes.number,
  campaignStatus: PropTypes.number,
  campaignName: PropTypes.string,
  certifierUserKey: PropTypes.number,
  certifier: PropTypes.string,
  campaigntype: PropTypes.string,
  createdate: PropTypes.string,
  startdate: PropTypes.string,
  enddate: PropTypes.string,
  dueIn: PropTypes.string,
  updateuser: PropTypes.string,
  updatedate: PropTypes.string,
  progress: PropTypes.string,
  comments: PropTypes.string,
  audit_trail: PropTypes.string,
  availableCertificationAction: PropTypes.string,
  certificationLockDate: PropTypes.string,
  certificationConfig: PropTypes.shape({
    reassignComments: PropTypes.bool,
  }),
  tracker: PropTypes.shape({
    id: PropTypes.number,
    isChecked: PropTypes.bool,
    actions: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default CERT_TILE_MOCK_DATA;
